import RSVP from 'rsvp';
import _ from 'underscore';
import $ from 'jquery';
import axios from 'axios';
import SessionStore from 'stores/shared/session';
import BookingRequestStore from 'stores/plugins/booking_request';
import StripeService from 'services/stripe';

const CARD_FIELDS = ['card_number', 'card_expiration', 'card_cvc'];

const BookingRequestService = {
  save(bookingRequestParams, shouldCommit) {
    let _this;
    let params;
    let cardParams;
    _this = this;

    // Separate card params
    cardParams = _.pick(bookingRequestParams, CARD_FIELDS);
    // Build params to send to the server
    params = this._buildRequestParams(bookingRequestParams);

    return new RSVP.Promise((resolve, reject) => {
      if (_this._shouldTokenizeCard(cardParams, params)) {
        _this._tokenizeCardAndSave(
          cardParams,
          params,
          shouldCommit,
          resolve,
          reject
        );
      } else {
        _this._saveActual(params, shouldCommit, resolve, reject);
      }
    });
  },

  commit(params) {
    return this.save(params, true);
  },

  applyDiscount(bookingRequestParams) {
    const params = this._buildRequestParams(bookingRequestParams);
    return new RSVP.Promise((resolve, reject) => {
      $.ajax({
        type: 'PATCH',
        url: `/api/booking_requests/${params.booking_request.id}/apply_discount.json`,
        data: JSON.stringify(params),
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        success: resolve,
        error: (xhr, textStatus, error) => {
          xhr.discountErrorHandled = true;
          reject(xhr, textStatus, error);
        },
      });
    });
  },

  removeDiscount(bookingRequestParams) {
    const params = this._buildRequestParams(bookingRequestParams);

    return new RSVP.Promise((resolve, reject) => {
      $.ajax({
        type: 'DELETE',
        url: `/api/booking_requests/${params.booking_request.id}/remove_discount.json`,
        data: JSON.stringify(params),
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        success: resolve,
        error: (xhr, textStatus, error) => {
          xhr.discountErrorHandled = true;
          reject(xhr, textStatus, error);
        },
      });
    });
  },

  fetchSummary(params) {
    return new RSVP.Promise((resolve, reject) => {
      return $.ajax({
        url: `/api/booking_requests/${params.id}/summary.json`,
        success: resolve,
        error: reject,
      });
    });
  },

  _tokenizeCardAndSave(cardParams, params, shouldCommit, resolve, reject) {
    const _this = this;
    StripeService.tokenizeCard(cardParams, params)
      .then(
        (stripe_token) => {
          params.booking_request.stripe_token = stripe_token;
          _this._saveActual(params, shouldCommit, resolve, reject);
        },

        (errors) => {
          reject({ errors });
        }
      )
      .catch((e) => {
        throw e;
      });
  },

  _saveActual(params, shouldCommit, resolve, reject) {
    const { id } = params.booking_request;
    $.ajax(
      _.extend(this._getRequest(id, shouldCommit), {
        data: JSON.stringify(params),
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        success: resolve,
        error(xhr, textError, err) {
          reject(xhr.responseJSON);
        },
      })
    );
  },

  _getRequest(id, shouldCommit) {
    if (!!id && shouldCommit) {
      return {
        type: 'POST',
        url: `/api/booking_requests/${id}/commit.json`,
      };
    }
    if (id) {
      return {
        type: 'PATCH',
        url: `/api/booking_requests/${id}.json`,
      };
    }
    return {
      type: 'POST',
      url: '/api/booking_requests/',
    };
  },

  _shouldTokenizeCard(cardParams, requestParams) {
    return (
      !(BookingRequestStore.state.get('fully_discounted') === true) &&
      !_.isEmpty(cardParams)
    );
  },

  _buildRequestParams(_params) {
    const params = _.omit(_params, CARD_FIELDS);
    return _.extend(
      {
        booking_request: _.extend(params, {
          currency: SessionStore.state.get('currency'),
          i18n: _params.i18n || SessionStore.state.get('i18n'),
        }),
      },
      SessionStore._getCSRFTokenObject()
    );
  },

  updatePayment(params) {
    const headers = {
      headers: {
        'X-CSRF-TOKEN': document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute('content'),
      },
    };
    const { id, status } = params;
    return axios.patch(`/api/payments/${id}`, { status }, headers);
  },
};

export default BookingRequestService;
